// extracted by mini-css-extract-plugin
export default {"errorText":"DropZoneUploader_errorText__6F+O6","errorIcon":"DropZoneUploader_errorIcon__dU3pv"};